import * as types from './types';
import { startSubmit, stopSubmit } from 'redux-form';

export const postLicenseFile = (formData, fiscalYear) => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(startSubmit('LicenseForm'));
    return new Promise((resolve, reject) => {
      MPWWebApi.licenseApi
        .postLicenseFile(formData, fiscalYear)
        .then(response => {
          dispatch({
            type: types.LICENSE_IMPORT,
            payload: response,
          });
          dispatch(stopSubmit('LicenseForm'));
          dispatch(getControlInfoExists());
          resolve(response);
        })
        .catch(error => {
          dispatch({
            type: types.LICENSE_ERROR,
            payload: error.response,
          });
          dispatch(stopSubmit('LicenseForm'));
          reject(error.response);
        });
    });
  };
};

export const getControlInfoExists = () => {
  return (dispatch, getState, MPWWebApi) => {
    MPWWebApi.licenseApi
      .getControlInfoExists()
      .then(response => {
        dispatch({
          type: types.LICENSE_EXISTS,
          payload: response,
        });
      })
      .catch(error => {
        dispatch({
          type: types.LICENSE_EXISTS,
          payload: error.response,
        });
      });
  };
};

export const clearLicenseErrors = () => {
  return {
    type: types.LICENSE_CLEAR_ERROR,
  };
};

export const clearLicenseData = () => {
  return {
    type: types.LICENSE_CLEAR_DATA,
  };
};

export const setLicenseErrors = message => {
  return {
    type: types.LICENSE_ERROR,
    payload: {
      data: {
        Data: [],
        Errors: [{ Title: 'Error', Message: `${message}`, Scenario: null }],
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/pages/license/state/actions.js